import type { ElementType } from 'react';

import {
	PM_VALUE_KEY_EXTERNAL_GENERAL,
	PM_VALUE_KEY_PAY_AT_PICKUP,
	PM_VALUE_KEY_SQUARE_CC,
	PM_VALUE_KEY_STRIPE_CC,
	PM_VALUE_KEY_TRANSBANK_WEBPAY,
} from '@/constants/payment-methods';

import NoPaymentExternalGeneral from './no-payment/NoPaymentExternalGeneral';
import NoPaymentPayAtPickup from './no-payment/NoPaymentPayAtPickup';
import SquareCCPaymentInput from './square/SquareCCPaymentInput';
import StripeCCPaymentInput from './stripe/StripeCCPaymentInput';
import TransbankPaymentInit from './transbank/TransbankPaymentInit';


// Checkout input component for each payment method key. These must NOT live in @/constants/payment-methods: the
// models import that file, and the inputs import the models, so a top-level reference there is an import cycle that
// crashes at chunk load (TDZ). Resolved per call, not in a top-level map, so entering this module mid-cycle is safe.
// Store credit has no input (null, as before); CheckoutStepPaymentDetailsInput renders NoPaymentStoreCredit itself.

export function getPaymentInputComponent(key: string | null | undefined): ElementType | null {
	switch(key) {
		case PM_VALUE_KEY_EXTERNAL_GENERAL:
			return NoPaymentExternalGeneral;
		case PM_VALUE_KEY_PAY_AT_PICKUP:
			return NoPaymentPayAtPickup;
		case PM_VALUE_KEY_SQUARE_CC:
			return SquareCCPaymentInput;
		case PM_VALUE_KEY_STRIPE_CC:
			return StripeCCPaymentInput;
		case PM_VALUE_KEY_TRANSBANK_WEBPAY:
			return TransbankPaymentInit;
		default:
			return null;
	}
}
